import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export const makeHostInfoSupports = supports => _objectSpread({
  context: false,
  accessToken: false,
  enabled: false
}, supports);
export const makeContext = context => _objectSpread({
  id: '',
  orgId: '',
  workspaceAri: ''
}, context);
export const makeHostInfo = hostInfo => _objectSpread(_objectSpread(_objectSpread({
  product: '',
  baseUrl: ''
}, hostInfo), hostInfo.supports && {
  supports: makeHostInfoSupports(hostInfo.supports)
}), hostInfo.globalContext && {
  globalContext: makeContext(hostInfo.globalContext)
});
export const makeContextFromSPIContext = spiContext => makeContext({
  id: spiContext.id,
  icon: spiContext.icon,
  name: spiContext.name,
  type: spiContext.type,
  orgId: spiContext.orgId,
  workspaceAri: spiContext.workspaceAri
});